import {showNotification} from 'platform/components';

import {downloadBlobFile} from './downloadBlobFile';

/**
 * @about function to download files provided by storage service, these files cannot be downloaded by ./downloadFile.ts,
 * since storage service thanks to internal redirects would overwrite files name. therefore we need to download file locally first.
 * @param url -> url to the hosted file
 * @param fileName  -> optional file name
 * @returns true when the file was handed to the browser for download, false when the download failed
 * (the user already saw an error notification in that case)
 */
export const downloadHostedFile = (url: string, fileName?: string): Promise<boolean> =>
  fetch(url)
    .then((res) => {
      if (!res.ok) {
        throw new Error('Unable to download hosted file: ' + res.status);
      }

      return res.blob();
    })
    .then((file) => {
      downloadBlobFile(file, fileName ?? 'file');
      return true;
    })
    .catch(() => {
      showNotification.error();
      return false;
    });
